import { render, staticRenderFns } from "./ConfirmPhoneNumber.vue?vue&type=template&id=5827883a&scoped=true&lang=pug&"
import script from "./ConfirmPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPhoneNumber.vue?vue&type=style&index=0&id=5827883a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827883a",
  null
  
)

export default component.exports